<script lang="ts" setup>
import { onMounted } from 'vue'
import { contactUs } from '~/resources/contact-us'
import { useDevice } from '#imports'
import {
  HIDE_ARROW_TIMEOUT,
  SCROLL_THRESHOLD_DESKTOP,
  SCROLL_THRESHOLD_MOBILE,
  HEIGHT_HERO_BANNER_DESKTOP,
  HEIGHT_HERO_BANNER_MOBILE,
  LIST_SHOW_SCROLL_TO_TOP,
  LIST_SHOW_SCROLL_TO_TOP_ABSOLUTE_PATH,
} from '~/constants'
import { useCustomLiveChat } from '~/composables/use-custom-live-chat'

const {
  TELEGRAM_CHAT_BOT,
  TELEGRAM_LINK,
  YOUTUBE_LINK,
  FANPAGE_LINK,
  BRAND_NAME,
} = useRuntimeConfig().public
const { isDesktopOrTablet, isMobile, isDesktop } = useDevice()
const { openLiveChat } = useCustomLiveChat()
const route = useRoute()
const isHideArrowToggle = ref(false)
const timeout = ref()
const isHideContact = ref(true)

onMounted(() => {
  scrollToTop()
  scrollMenuTop()
})
onBeforeUnmount(() => {
  if (timeout.value) {
    clearTimeout(timeout.value)
  }
})

const hideArrowMenu = () => {
  scrollToTop()
  if (timeout.value) {
    clearTimeout(timeout.value)
  }
  timeout.value = setTimeout(() => {
    isHideArrowToggle.value = false
  }, HIDE_ARROW_TIMEOUT)
}
const scrollMenuTop = () => {
  window.addEventListener('scroll', () => {
    const { scrollTop } = document.documentElement
    if (isDesktopOrTablet) {
      isHideArrowToggle.value =
        scrollTop >= HEIGHT_HERO_BANNER_DESKTOP / SCROLL_THRESHOLD_DESKTOP
    } else {
      isHideArrowToggle.value =
        scrollTop >= HEIGHT_HERO_BANNER_MOBILE - SCROLL_THRESHOLD_MOBILE
    }
  })
}
const isShowScrollToTop = (): boolean => {
  if (isDesktop) {
    return true
  }
  return (
    LIST_SHOW_SCROLL_TO_TOP_ABSOLUTE_PATH.some((item) =>
      route.path.includes(item),
    ) || LIST_SHOW_SCROLL_TO_TOP.includes(route.path)
  )
}

const handleToggleContact = () => {
  isHideContact.value = !isHideContact.value
}
</script>
<template>
  <div
    :class="[
      'ctn-chat-bubble',
      {
        'ctn-chat-bubble--mobile': isMobile,
        'ctn-chat-bubble--hide': isHideContact,
        'btn-back-to-top': isShowScrollToTop(),
      },
    ]"
  >
    <div v-if="!isHideContact" class="chat-bubble">
      <div class="chat-bubble__expand">
        <span class="icon-arrow icon-right" @click="handleToggleContact" />
      </div>

      <NuxtLink :to="YOUTUBE_LINK" target="_blank" class="chat-bubble__item">
        <div class="icon">
          <img
            src="/icons/icon-youtube.svg"
            width="32"
            height="32"
            alt="Telegram"
          />
        </div>
        <div class="name fs-12 fw-600 color-dark-blue">Youtube</div>
      </NuxtLink>
      <div class="chat-bubble__item" @click="openLiveChat()">
        <div class="icon">
          <img
            :src="contactUs.img"
            :alt="contactUs.title"
            width="32"
            height="32"
          />
        </div>
        <div class="name fs-12 fw-600 color-dark-blue">
          {{ contactUs.title }}
        </div>
      </div>
      <NuxtLink
        :to="TELEGRAM_CHAT_BOT"
        target="_blank"
        class="chat-bubble__item"
      >
        <div class="icon">
          <img
            src="/icons/icon-telegram.svg"
            alt="Telegram icon"
            width="32"
            height="32"
          />
        </div>
        <div class="name fs-12 fw-600 color-dark-blue">CSKH</div>
      </NuxtLink>
      <NuxtLink :to="TELEGRAM_LINK" target="_blank" class="chat-bubble__item">
        <div class="icon">
          <img
            src="/icons/icon-telegram.svg"
            alt="Telegram icon"
            width="32"
            height="32"
          />
        </div>
        <div class="name fs-12 fw-600 color-dark-blue">
          Kênh {{ BRAND_NAME }}
        </div>
      </NuxtLink>
      <NuxtLink :to="FANPAGE_LINK" target="_blank" class="chat-bubble__item">
        <div class="icon">
          <img
            format="webp"
            src="/icons/icon-facebook.svg"
            alt="Telegram"
            width="32"
            height="32"
          />
        </div>
        <div class="name fs-12 fw-600 color-dark-blue">Fanpage</div>
      </NuxtLink>
    </div>
    <div
      v-if="!isMobile && isHideContact"
      class="chat-support-contract chat-bubble__item"
      @click="handleToggleContact"
    >
      <img src="/icons/icon-support.svg" alt="support" width="32" height="32" />
    </div>

    <div
      v-if="isShowScrollToTop()"
      :class="[
        'ctn-scroll',
        { visible: isHideArrowToggle, small: isHideContact },
      ]"
      @click="hideArrowMenu()"
    >
      <img
        class="icon-arrow"
        src="/icons/ic-arrow-scroll.svg"
        alt="Icon plus"
        width="16"
        height="16"
      />
    </div>
  </div>
</template>
<style
  lang="scss"
  scoped
  src="~/assets/styles/components/desktop/common/contact.scss"
></style>
